import React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'
const BulmaConfirmModal = ({
  headerTitle,
  children,
  confirmTitle = 'Save changes',
  isSubmitting = false,
  isValid,
  onClose,
  onConfirm,
}) => (
  <React.Fragment>
    <div className="modal-background" />
    <div className="modal-card">
      <header className="modal-card-head">
        <p className="modal-card-title">{headerTitle}</p>
        <button className="delete" aria-label="close" onClick={onClose} />
      </header>
      <section className="modal-card-body">{children}</section>
      <ModalFooter>
        <button className="button" onClick={onClose}>
          ยกเลิก
        </button>
        <button
          type="submit"
          className={classNames('button', 'is-success', {
            'is-loading': isSubmitting,
          })}
          disabled={!isValid}
          onClick={onConfirm}
        >
          {confirmTitle}
        </button>
      </ModalFooter>
    </div>
  </React.Fragment>
)

const ModalFooter = styled.footer.attrs({
  className: 'modal-card-foot',
})`
  justify-content: flex-end !important;
`

export default BulmaConfirmModal



// WEBPACK FOOTER //
// ./src/modules/modal/BulmaConfirmModal.js